export default __webpack_public_path__ + "static/media/iPhone-X3.6106f7af.png";